import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

import { Label } from './Label';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  errorMessage?: string;
  icon?: ReactNode;
};

export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ className, label, id, errorMessage, icon, ...rest }, ref) => {
    return (
      <div>
        {label ? (
          <Label htmlFor={id} className={twJoin(!!errorMessage && 'text-red-700 dark:text-red-500')}>
            {label}
          </Label>
        ) : null}
        <div className="relative">
          {icon ? (
            <div className="absolute left-0 top-0 bottom-0 flex items-center justify-center w-10 text-gray-500 dark:text-gray-400">
              {icon}
            </div>
          ) : null}
          <input
            {...rest}
            ref={ref}
            id={id}
            className={twMerge(
              'bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500',
              !!errorMessage &&
                'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500',
              !!icon && 'pl-10',
              className,
            )}
          />
        </div>
        {errorMessage ? <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errorMessage}</p> : null}
      </div>
    );
  },
);

TextInput.displayName = 'TextInput';
